import { Modal, Radio } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  loaderMergeGroup,
  maxTablet,
  primaryColor, primaryFont, wMBold,
} from 'Utils/utilsStyle';
import MergeInputModal from 'Components/people/components/MergeInputModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectMergeGroupsLoading, selectSelectedGroups } from 'Selector/GroupsSelector';
import MergeGroupSVG from '../assets/svgIcons/MergeGroupSVG';
import { actions as groupActions } from '../../../Slice/GroupsSlice';

const Wrapper = styled.div`
.merge-button-group {
  background-color: ${primaryColor};
  border: 2px solid ${primaryColor};
  height: 30px;
  border-radius: 17px;
  padding: 7px 16px;
  font-family: ${primaryFont};
  color: #fff;
  font-weight: ${wMBold};
  font-size: 14px;
  line-height: 17.09px;
  cursor: pointer;
   @media all and (max-width: ${maxTablet}){
    padding: 2px 13px;
    font-size: 12px;
    line-height: normal;
    height: 22px;
    display: flex;
   }
}
`;

const MergeGroupPeopleModal = function MergeGroupPeopleModal() {
  const [showPopup, setShowPopup] = useState(false);
  const [currentRadio, setCurrentRadio] = useState<null | 'keep' | 'delete'>(null);
  const [inputValue, setInputValue] = useState('');
  const selectedGroups = useSelector(selectSelectedGroups);
  const mergeLoading = useSelector(selectMergeGroupsLoading);
  const dispatch = useDispatch();

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(!showPopup);
    setCurrentRadio(null);
  };

  const handleKeepRadio = () => setCurrentRadio('keep');
  const handleDeleteRadio = () => setCurrentRadio('delete');

  const handleSave = () => {
    if (currentRadio) {
      dispatch(
        groupActions.mergeGroups({
          deleteExisting: currentRadio === 'delete',
          groupIds: selectedGroups.map((group) => group.id).join(','),
          groupName: inputValue.trim(),
        }),
      );
    }
  };

  const handleInputChange = (value: string) => {
    setInputValue(value);
    dispatch(groupActions.setGroupMergeError(''));
  };

  return (
    <Wrapper>
      <span
        role="button"
        tabIndex={0}
        onClick={openPopup}
        onKeyPress={openPopup}
        className={classNames('merge-button-group', { disabled: selectedGroups.length < 2 })}
      >
        Merge Groups
      </span>
      {showPopup && (
        <Modal
          centered
          open={showPopup}
          onCancel={() => closePopup()}
          width={582}
          wrapClassName={classNames('merge-group-with-people-popup', { loaderState: mergeLoading })}
          closable
          cancelText="Cancel"
          okText="Save"
          okButtonProps={{ disabled: !currentRadio || !inputValue.trim() || mergeLoading }}
          onOk={handleSave}
        >
          {mergeLoading
            ? <img className="loading-merge" src={loaderMergeGroup} alt="Loading..." />
            : (
              <>
                <div className="merge-group-header">
                  <MergeGroupSVG />
                  <h3 className="header-text">Merge Groups</h3>
                </div>
                <MergeInputModal inputValue={inputValue} setInputValue={handleInputChange} />
                <p className="options-text main">Options:</p>
                <div className="merge-group-options-div">
                  <div className="merge-group-options">
                    <Radio onClick={handleKeepRadio} checked={currentRadio === 'keep'} />
                    <p className="options-text">Keep existing Groups</p>
                  </div>
                  <div className="merge-group-options">
                    <Radio onClick={handleDeleteRadio} checked={currentRadio === 'delete'} />
                    <p className="options-text">Delete existing Groups</p>
                  </div>
                </div>
              </>
            )}

        </Modal>
      )}
    </Wrapper>
  );
};

export default MergeGroupPeopleModal;
